import { isMainLotteryDraw } from 'components/how-it-works/GameSelector';
import { ASSET_PREFIX } from 'utils/constants';

export const getTicketFields = (
  drawTypeCode: string,
  drawTypePlanCode: string,
  numberOfEntries: number
) => {
  let ticketType: string | undefined;
  let ticketBanner: string | undefined;

  if (isMainLotteryDraw(drawTypeCode)) {
    switch (drawTypePlanCode) {
      case 'LITE':
        ticketType = `Lite entr${numberOfEntries === 1 ? 'y' : 'ies'}`;
        ticketBanner = `${ASSET_PREFIX}/images/account/entries/ticket-banners/lite.jpg`;
        break;

      case 'FREEMIUM':
        ticketType = `Free entr${numberOfEntries === 1 ? 'y' : 'ies'}`;
        ticketBanner = `${ASSET_PREFIX}/images/account/entries/ticket-banners/freemium.jpg`;
        break;

      default:
        ticketType = `Premium entr${numberOfEntries === 1 ? 'y' : 'ies'}`;
        ticketBanner = `${ASSET_PREFIX}/images/account/entries/ticket-banners/premium.jpg`;
        break;
    }
  }
  
  return { ticketType, ticketBanner };
};
